<section id="login" class="login-page">
  <div class="login-grid">

    <div class="login-form-col">
      <div class="login-form-shell">
        <div class="login-brand">
          <img src="/assets/img/brand/mymeds-logo-mark.svg" alt="MyMedsPH" class="login-brand-mark" />
          <span class="login-brand-name"><span class="login-brand-name-orange">MyMeds</span><span class="login-brand-name-blue">PH</span></span>
        </div>

        <header class="login-greeting">
          <h1>Welcome Back</h1>
          <p>Sign in to your clinic dashboard.</p>
        </header>

        <ngb-alert class="login-alert" [dismissible]="false" *ngIf="alert && alert.error" (close)="alert = {}">
          {{ alert.error }}
        </ngb-alert>

        <form novalidate (ngSubmit)="onSubmit()" #f="ngForm" class="login-form">
          <div class="login-field">
            <label for="email">Email</label>
            <input
              type="email"
              class="form-control"
              name="email"
              id="email"
              placeholder="you@clinic.com"
              [(ngModel)]="email"
              required
              email
              autocomplete="on"
            />
          </div>

          <div class="login-field">
            <label for="password">Password</label>
            <input
              type="password"
              class="form-control"
              name="password"
              id="password"
              placeholder="Enter your password"
              [(ngModel)]="password"
              required
              autocomplete="on"
            />
          </div>

          <div class="login-privacy">
            <input
              type="checkbox"
              [(ngModel)]="privacy"
              name="privacy"
              id="privacy"
              class="login-privacy-input"
            />
            <label for="privacy" class="login-privacy-label">
              I agree to the
              <a target="_blank" href="https://mymedsph.com/privacy" rel="noopener noreferrer">Privacy Policy</a>
            </label>
          </div>

          <button type="submit" class="login-submit btn btn-info btn-block btn-raised">
            <span *ngIf="!submitted">Sign in</span>
            <span *ngIf="submitted"><i class="fas fa-circle-notch fa-spin"></i> Signing you in…</span>
          </button>
        </form>

        <footer class="login-footer">
          <a (click)="onForgotPassword()" class="login-forgot">Forgot your password?</a>
        </footer>
      </div>
    </div>

    <aside class="login-brand-panel" aria-hidden="true">
      <div class="brand-panel-glow"></div>
      <div class="brand-panel-mark">
        <img src="/assets/img/brand/mymeds-logo-mark.svg" alt="" />
      </div>
      <div class="brand-panel-content">
        <p class="brand-panel-eyebrow">Practice Management</p>
        <h2>Built for Filipino Dental Clinics</h2>
        <p>Schedule appointments, chart patients, and manage your day — all in one place.</p>
        <ul class="brand-panel-features">
          <li><i class="far fa-clock" aria-hidden="true"></i><span>Daily waitlist &amp; live patient queue</span></li>
          <li><i class="far fa-calendar-alt" aria-hidden="true"></i><span>Appointments &amp; online bookings</span></li>
          <li><i class="fas fa-tooth" aria-hidden="true"></i><span>Charting, treatment plans &amp; billing</span></li>
        </ul>
      </div>
      <div class="brand-panel-footer">
        <span>© {{ today | date:'y' }} MyMedsPH</span>
        <a href="https://mymedsph.com" target="_blank" rel="noopener noreferrer">mymedsph.com</a>
      </div>
    </aside>

  </div>
</section>
